import * as React from "react";
import { CoveragePrivateSelect } from "../../../components/FormComponents/CoveragePrivateSelect";
import { Field } from "formik";
import { InputField } from "@coverme/forms";
import { SimpleSingleSelect } from "../../../components/FormComponents/SimpleSingleSelect";

export const HealthInsuranceForm = ({
    insurance,
    getErrors,
    getValidationState,
    patientName,
    insuranceType,
    typesOfCoverage,
    isRequired,
    setFieldValue,
    ...props
}) => {
    if (isRequired == null) {
        isRequired = () => false;
    }
    return (
        <>
            <div className="form-control l-input">
                <Field
                    name={`${insuranceType}.typeOfCoverage`}
                    render={({ field }) => (
                        <SimpleSingleSelect
                            {...field}
                            {...props}
                            setFieldValue={setFieldValue}
                            id={`${insuranceType}.typeOfCoverage`}
                            title={`Select provider`}
                            errorMessage={getErrors(field)}
                            required={isRequired(field)}
                            validState={getValidationState(field)}
                            options={typesOfCoverage}
                        />
                    )}
                />
            </div>
            {["Other"].includes(insurance.typeOfCoverage) && (
                <div className="form-control m-input">
                    <Field name={`${insuranceType}.companyNameOther`}>
                        {({ field }) => (
                            <InputField
                                {...field}
                                id={field.name}
                                title="Specify Company Name"
                                placeholder="Specify Company Name"
                                errorMessage={getErrors(field)}
                                required={isRequired(field)}
                                validState={getValidationState(field)}
                            />
                        )}
                    </Field>
                </div>
            )}
            <div className="form-control m-input">
                <Field
                    name={`${insuranceType}.memberNumber`}
                    render={({ field }) => (
                        <InputField
                            id={`${insuranceType}.memberNumber`}
                            title={"Member Number"}
                            placeholder={"Member Number"}
                            errorMessage={getErrors(field)}
                            required={isRequired(field)}
                            validState={getValidationState(field)}
                            {...field}
                        />
                    )}
                />
            </div>
        </>
    );
};
